import styled from 'styled-components';

export const Container = styled.div`
    background-color: var(--theme-color-secondary);
    border-radius: 1rem;
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    @media only screen and (max-width: 1023px) {
    padding: 24px 20px;
  }
`;

export const TopRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    text-transform: capitalize;
    flex-wrap: wrap;
`;

export const IconBox = styled.div`
    background: ${props => {
        switch(props.$variant) {
          case 'success':
            return 'var(--color-success)';
          case 'error':
            return 'var(--color-error)';
          default:
            return 'var(--theme-color-primary)';
        }
    }};
    border-radius: 10px;
    width: 35px;
    height: 35px; 
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
        width: 20px;
        height: 20px;
        color: var(--theme-color-white);
    }
`;

export const Label = styled.div`
    color: var(--text-color-primary);
    font-size: 16px;
    font-weight: 500;
    flex: 1;
    word-break: break-word;
    
    @media only screen and (max-width: 600px) {
        font-size: 16px;
    }
`;

export const StatRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const StatIcon = styled.span`
    font-size: 16px;
    display: flex;
    align-items: center;

    svg {
        width: 20px;
        height: 20px;
        transform: scaleY(${props => (props.$downward ? '1' : '-1')}) rotate(1deg);
        color: ${props => (props.$downward === undefined ? 'var(--text-color-secondary)' : props.$downward ? 'var(--color-error)' : 'var(--color-success)' )};
        transition: all ease-in-out 0.3s;
    }
    
    @media only screen and (max-width: 575px) {
        svg {
            width: 16px;
            height: 16px;
        }
    }
`; 

export const StatValue = styled.span`
    font-weight: 500;
    font-size: 16px;
    color: ${props => (props.$downward === undefined ? 'var(--text-color-secondary)' : props.$downward ? 'var(--color-error)' : 'var(--color-success)')};
    transition: all ease-in-out 0.3s;
`;

export const StatLabel = styled.span`
    color: var(--text-color-secondary);
    font-size: 12px;
`;